import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=5b06e008&scoped=true"
import script from "./SocialIcons.js?vue&type=script&lang=js&external"
export * from "./SocialIcons.js?vue&type=script&lang=js&external"
import style0 from "./SocialIcons.scss?vue&type=style&index=0&id=5b06e008&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06e008",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default,HotLink: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/HotLink/HotLink.vue').default})
